import React, { Component } from 'react';
import { Button } from 'semantic-ui-react'
import { withTranslation } from "react-i18next";


class BookingButtonNoTranslation extends Component {
  static propTypes = {

  };

  render() {
    const { t } = this.props;
    return (
      <div className="common-booking-button">
        <a
          className=""
          href="http://www.booking.com/Share-RRy84JH"
        >
          <Button size='tiny' primary fluid>{t('general.bookingButtonText', { framework: 'React' })} </Button>
        </a>
      </div>
    );
  }
}


const BookingButton = withTranslation('common')(BookingButtonNoTranslation)

export default BookingButton;


// WEBPACK FOOTER //
// ./src/features/common/BookingButton.js